export default __webpack_public_path__ + "static/media/breakthrough.e0b9edd7.png";